export const UserData = state => state.user.data;
export const isAuth = state => sessionStorage.getItem('auth') || state.user.data ? true : false;

